import { AuthenticateClient } from './fo.api.service';
import axios from 'axios';

const API_URL = `${window.config?.VITE_API_HOST}`;

class AuthService {
  login(user) {
    const _axios = axios.create({
      baseURL: API_URL,
      transformResponse: data => data // this line here
    });
    const authClient = new AuthenticateClient(API_URL, _axios);
    return authClient
      .login({
        username: user.username,
        password: user.password,
      })
      .then(function (value) {
        console.log(value);
        localStorage.setItem('user', JSON.stringify(value.result));
        return value;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }
}

export default new AuthService();
